import React from 'react';
import {
  ContentColumns as ContentColumnsComponent,
  ContentColumnsProps,
} from '@raisin/components-lib';
import { getUpdatedExternalLink } from '../../utils/helpers';

export const ContentColumns: React.FC<ContentColumnsProps> = (props) => {
  const updatedProps = {
    ...props,
    content_columns: props?.content_columns?.map((column) => ({
      ...column,
      content: column?.content?.map((item) => ({
        ...item,
        cta: item?.cta && {
          ...item.cta,
          external_link: getUpdatedExternalLink(item.cta?.external_link, props?.locale),
          external_link_for_logged_in_users: getUpdatedExternalLink(
            item.cta?.external_link_for_logged_in_users,
            props?.locale,
          ),
        },
      })),
    })),
  };

  return <ContentColumnsComponent data-testId="mocked-content-columns" {...updatedProps} />;
};
